import React from 'react';
import WaveOverlay from './WaveOverlay';

const HeroSection = ({ children, className = "", textOnly = false }) => {
  return (
    <section className={`hero-gradient text-white relative ${textOnly ? 'py-20' : 'py-32'} ${className}`}>
      <div className="container mx-auto px-4 relative z-30">
        {children}
      </div>
      
      {/* White Swoop Overlay - Only show for standard layouts */}
      {!textOnly && <WaveOverlay />}
    </section>
  );
};

export default HeroSection; 